import { memo } from "react";
import { Button, Icon } from "orcs-design-system";
import PropTypes from "prop-types";

import icons from "src/config/icons";

const TagsFormButton = ({ onClick, icon, caption }) => (
  <Button onClick={onClick} ariaLabel={caption} variant="ghost" small>
    <Icon icon={icon} />
    {caption}
  </Button>
);

const defaultEditCaption = ({ isTagsEmpty, isAssociationTag }) =>
  `${isTagsEmpty ? "Add" : "Edit"} ${
    isAssociationTag ? "association" : "tags"
  }`;

const TagEditBtn = ({
  // todo: user testing on this, or at least change the icon ?
  showFinishButton = false,
  editMode,
  isTagsEmpty,
  onEditClicked,
  onFinishEditClicked,
  isAssociationTag,
  editButtonLabel,
  icon,
}: {
  showFinishButton?: boolean;
  editMode?: boolean;
  isTagsEmpty?: boolean;
  onEditClicked: () => void;
  onFinishEditClicked: () => void;
  isAssociationTag?: boolean;
  editButtonLabel?: string;
  icon?: unknown;
}) => {
  return (
    <>
      {editMode && showFinishButton && (
        <TagsFormButton
          onClick={onFinishEditClicked}
          caption="Finish"
          icon={icons.save}
        />
      )}

      {!editMode && (
        <TagsFormButton
          onClick={onEditClicked}
          caption={
            editButtonLabel ||
            defaultEditCaption({ isTagsEmpty, isAssociationTag })
          }
          icon={Array.isArray(icon) ? icon : icons.pen}
        />
      )}
    </>
  );
};
TagsFormButton.propTypes = {
  icon: PropTypes.array.isRequired,
  caption: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
TagEditBtn.propTypes = {
  editMode: PropTypes.bool,
  showFinishButton: PropTypes.bool,
  isTagsEmpty: PropTypes.bool,
  onEditClicked: PropTypes.func.isRequired,
  onFinishEditClicked: PropTypes.func.isRequired,
  isAssociationTag: PropTypes.bool,
  editButtonLabel: PropTypes.string,
};

export default memo(TagEditBtn);
